import type { SubscriptionsDto } from 'components/Admin/organisms/Subscriptions/types';
import { endpoints } from 'store/endpoints';
import type { SubscriptionPackage } from 'store/slices/subscriptions/subscriptions.slice';
import type { CreateSubscriptionRequest } from 'store/slices/subscriptions/subscriptions.slice';
import { axiosInstance } from './axiosInstance';

export class SubscriptionsService {
  static async createSubscription(
    payload: CreateSubscriptionRequest & { paymentMethodId: string },
  ) {
    try {
      const response = await axiosInstance.post(
        endpoints.subscriptions.general,
        payload,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async getSpecificSubscription(id: string) {
    try {
      const response = await axiosInstance.get<SubscriptionsDto>(
        endpoints.subscriptions.opWithId(id),
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
  static async getAll(params: Partial<SubscriptionsDto>) {
    try {
      const response = await axiosInstance.get<Array<SubscriptionsDto>>(
        endpoints.subscriptions.general,
        {
          params,
        },
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async getSubscriptionPackages() {
    try {
      const response = await axiosInstance.get(
        endpoints['subscription-packages'].general,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async updateSubscriptionPackage(
    body: Partial<SubscriptionPackage>,
    id: string,
  ) {
    try {
      const response = await axiosInstance.patch(
        endpoints['subscription-packages'].opWithId(id),
        body,
      );
      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }

  static async stopSubscription(id: string) {
    try {
      const response = await axiosInstance.patch(
        endpoints.subscriptions.stopSubscription(id),
      );

      return response.data;
    } catch (err: any) {
      throw new Error(err);
    }
  }
}
